/**  MODIFIED COPY OF src/common-app/state/modules/engines/voice-mask/reducers.ts TODO find way to reuse common code! */
import { Lens } from 'monocle-ts';

import * as Actions from './actions';
import {
  defaultState,
  defaultJobSlice,
  FAILED_STATUSES,
  JobState,
  JobStore,
} from './store';
import { TDOId } from '../../universal/models/Brands';
import { createReducer } from '@reduxjs/toolkit';
import { GetActionCreatorPayloadT } from '@utils';

const engineGroup = (tdoId: TDOId) =>
  Lens.fromNullableProp<JobStore>()(tdoId, {});
const engineJob = (jobId: string) =>
  Lens.fromNullableProp<NonNullable<JobStore['']>>()(jobId, defaultJobSlice());
const getJob = (tdoId: TDOId, jobId: string) =>
  engineGroup(tdoId).compose(engineJob(jobId)).get;
const modifyJob = (
  tdoId: TDOId,
  jobId: string,
  fn: (j: JobState) => JobState
) => engineGroup(tdoId).compose(engineJob(jobId)).modify(fn);

const processEngineRequestSuccess = (
  state: JobStore,
  { payload }: { payload: { tdoId: TDOId; jobId: string } }
) =>
  modifyJob(payload.tdoId, payload.jobId, (job) => ({
    ...job,
    isRunning: false,
    endedOn: new Date(),
    error: undefined,
  }))(state);

const createJobSuccess = (
  state: JobStore,
  {
    payload,
  }: {
    payload: GetActionCreatorPayloadT<typeof Actions.CREATE_ENGINE_JOB_SUCCESS>;
  }
) =>
  modifyJob(payload.createJob.targetId, payload.createJob.id, (_job) => ({
    jobId: payload.createJob.id,
    isRunning: true,
    status: 'pending',
    startedOn: new Date(),
    endedOn: undefined,
    error: undefined,
  }))(state);

const startPollingEngineResults = (
  state: JobStore,
  { payload }: { payload: { tdoId: TDOId; jobId: string } }
) =>
  modifyJob(payload.tdoId, payload.jobId, (job) => ({
    ...job,
    jobId: payload.jobId,
    isRunning: true,
    status: 'pending',
    error: undefined,
  }))(state);

const stopPollingEngineResults = (
  state: JobStore,
  { payload }: { payload: { tdoId: TDOId; jobId: string } }
) =>
  modifyJob(payload.tdoId, payload.jobId, (job) => ({
    ...job,
    isRunning: false,
  }))(state);

const checkJobStatusSuccess = (
  state: JobStore,
  {
    payload,
  }: {
    payload: {
      job: { targetId: TDOId; id: string; status: JobState['status'] };
    };
  }
) => {
  const currentStatus = getJob(
    payload.job.targetId,
    payload.job.id
  )(state).status;
  if (payload.job.status === currentStatus) {
    return state;
  }

  const isFailed = FAILED_STATUSES.includes(payload.job.status);

  return modifyJob(payload.job.targetId, payload.job.id, (job) => ({
    ...job,
    status: payload.job.status,
    isRunning: isFailed ? false : job.isRunning,
    endedOn: isFailed ? new Date() : job.endedOn,
    error: isFailed
      ? `Speaker separation job ${payload.job.status}`
      : job.error,
  }))(state);
};

export default createReducer(defaultState, (builder) => {
  builder
    .addCase(
      Actions.PROCESS_ENGINE_REQUEST_SUCCESS,
      processEngineRequestSuccess
    )
    .addCase(Actions.CREATE_ENGINE_JOB_SUCCESS, createJobSuccess)
    .addCase(Actions.START_POLLING_ENGINE_RESULTS, startPollingEngineResults)
    .addCase(Actions.STOP_POLLING_ENGINE_RESULTS, stopPollingEngineResults)
    .addCase(Actions.CHECK_JOB_STATUS_SUCCESS, checkJobStatusSuccess);
});
